//@flow
import * as React from 'react';
import { themr, type ThemeType } from 'react-css-themr';

import PjpChartTooltipItem from './PjpChartTooltipItem';

import defaultTheme from './PjpPieChartTooltip.scss';

const PjpPieChartTooltip = (props: {
    payload: Array<Object>,
    unit: string,
    theme: ThemeType
}) => {
    const [pieChart] = props.payload;

    if (!pieChart) {
        return null;
    }
    const { color } = pieChart.payload;

    return (
        <div className={props.theme.tooltip}>
            <PjpChartTooltipItem
                theme={props.theme}
                color={color}
                label={pieChart.name}
                value={pieChart.payload.value}
                valueType={props.unit}
                percentage={pieChart.percent}
            />
        </div>
    );
};

export default themr('PjpPieChartTooltip', defaultTheme)(PjpPieChartTooltip);
